require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./introduction-to-ogc.json") })
        }
      }, "path---introduction-to-ogc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---introduction-to-ogc!./.cache/json/introduction-to-ogc.json
// module id = 370
// module chunks = 231608221292675